export const useChart = () => {
  const calculateTrend = (data: [string, number][]): [string, number][] => {
    let sumX = 0, sumY = 0, sumXY = 0, sumXX = 0
    const n = data.length

    const numeric = data.map(([date, y]) => [new Date(date).getTime(), y] as [number, number])

    numeric.forEach(([x, y]) => {
      sumX += x
      sumY += y
      sumXY += x * y
      sumXX += x * x
    })

    const slope = (n * sumXY - sumX * sumY) / (n * sumXX - sumX * sumX)
    const intercept = (sumY - slope * sumX) / n

    return data.map(([date], i) => [date, slope * numeric[i][0] + intercept] as [string, number])
  }

  return {
    calculateTrend
  }
}
